export const formatter = (
  locale = 'en-US',
  style = 'currency',
  currency = 'USD',
  isDecimal = true,
) =>
  new Intl.NumberFormat(locale, {
    style: style as Intl.NumberFormatOptions['style'],
    currency,
    minimumFractionDigits: isDecimal ? 2 : 0,
    maximumFractionDigits: isDecimal ? 2 : 0,
  });

export const formatAmount = (
  amount: number | string | null | undefined,
  isDecimal = false,
): string =>
  amount !== undefined && amount !== null
    ? formatter('en-US', 'decimal', undefined, isDecimal).format(
        Number.parseFloat(`${amount}`),
      )
    : '---';

export const formatAmounts = (value: number) =>
  new Intl.NumberFormat('en-US', {
    useGrouping: true,
    maximumFractionDigits: 0,
  }).format(value);
